(function () {
  'use strict';

  const FOCUSABLE = 'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])';

  window.BP = window.BP || {};

  BP.lockScroll = function (lock) {
    document.body.classList.toggle('scroll-lock', !!lock);
  };

  BP.trapFocus = function (container, event) {
    const nodes = Array.from(container.querySelectorAll(FOCUSABLE)).filter(
      (el) => !el.hasAttribute('disabled') && el.offsetParent !== null
    );
    if (!nodes.length) return;
    const first = nodes[0];
    const last = nodes[nodes.length - 1];
    if (event.key !== 'Tab') return;
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  BP.toast = function (message) {
    let el = document.getElementById('bp-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'bp-toast';
      el.className = 'toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(BP._toastTimer);
    BP._toastTimer = setTimeout(() => el.classList.remove('is-visible'), 2800);
  };

  BP.openPanel = function (id) {
    const panel = document.getElementById(id);
    const backdrop = document.querySelector(`[data-backdrop-for="${id}"]`);
    if (!panel) return;
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    if (backdrop) backdrop.classList.add('is-open');
    BP.lockScroll(true);
    const focusTarget = panel.querySelector(FOCUSABLE);
    if (focusTarget) focusTarget.focus();
  };

  BP.closePanel = function (id) {
    const panel = document.getElementById(id);
    const backdrop = document.querySelector(`[data-backdrop-for="${id}"]`);
    if (!panel) return;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    if (backdrop) backdrop.classList.remove('is-open');
    const openPanels = document.querySelectorAll('.is-open[data-panel]');
    if (!openPanels.length) BP.lockScroll(false);
  };

  document.addEventListener('click', (e) => {
    const openBtn = e.target.closest('[data-open-panel]');
    if (openBtn) {
      e.preventDefault();
      BP.openPanel(openBtn.getAttribute('data-open-panel'));
    }
    const closeBtn = e.target.closest('[data-close-panel]');
    if (closeBtn) {
      e.preventDefault();
      BP.closePanel(closeBtn.getAttribute('data-close-panel'));
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      document.querySelectorAll('[data-panel].is-open').forEach((panel) => {
        BP.closePanel(panel.id);
      });
    }
    const open = document.querySelector('[data-panel].is-open');
    if (open) BP.trapFocus(open, e);
  });

  /* Sticky header shrink */
  const header = document.querySelector('[data-site-header]');
  if (header) {
    const root = document.documentElement;
    const onScroll = () => {
      const compact = window.scrollY > 40;
      header.classList.toggle('is-compact', compact);
      if (compact) {
        const compactH =
          getComputedStyle(root).getPropertyValue('--header-height-compact').trim() || '92px';
        root.style.setProperty('--header-height', compactH);
      } else {
        root.style.removeProperty('--header-height');
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Mega menu — keep open while hovering panel; delay close to cross the gap */
  (function initMegaMenu() {
    const header = document.querySelector('[data-site-header]');
    if (!header) return;

    let closeTimer = null;
    const isDesktop = () => window.matchMedia('(min-width: 1024px)').matches;
    const clickOnlyIds = new Set(['MegaContact', 'MegaSearch']);
    const searchPanel = () => document.getElementById('MegaSearch');
    const isSearchOpen = () => {
      const panel = searchPanel();
      return !!(panel && panel.classList.contains('is-open'));
    };

    const triggersFor = (panel) =>
      header.querySelectorAll(`[data-mega-trigger][aria-controls="${panel.id}"]`);

    const setTriggersExpanded = (panel, expanded) => {
      triggersFor(panel).forEach((trigger) => {
        trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    };

    const setSearchLock = (lock) => {
      document.body.classList.toggle('search-dropdown-open', !!lock);
    };

    const closeAll = () => {
      header.querySelectorAll('[data-mega-panel].is-open').forEach((panel) => {
        panel.classList.remove('is-open');
        setTriggersExpanded(panel, false);
      });
      setSearchLock(false);
    };

    const shuffleFeaturedBrandLogos = (panel) => {
      const grid = panel.querySelector('[data-featured-brand-logos]');
      if (!grid) return;
      const items = Array.from(grid.querySelectorAll('[data-featured-brand-logo]'));
      if (!items.length) return;
      const count = Math.min(Math.max(Number(grid.dataset.count) || 9, 1), 9, items.length);
      for (let i = items.length - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1));
        const tmp = items[i];
        items[i] = items[j];
        items[j] = tmp;
      }
      items.forEach((el, index) => {
        const visible = index < count;
        el.hidden = !visible;
        el.classList.toggle('is-featured-off', !visible);
        el.setAttribute('aria-hidden', visible ? 'false' : 'true');
        if (visible) el.removeAttribute('tabindex');
        else el.setAttribute('tabindex', '-1');
        grid.appendChild(el);
      });
    };

    const shuffleCatFeatured = (panel) => {
      const grid = panel.querySelector('[data-cat-featured]');
      if (!grid) return;
      const items = Array.from(grid.querySelectorAll('[data-cat-featured-item]'));
      if (!items.length) return;
      const count = Math.min(Math.max(Number(grid.dataset.count) || 4, 1), 4, items.length);
      for (let i = items.length - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1));
        const tmp = items[i];
        items[i] = items[j];
        items[j] = tmp;
      }
      items.forEach((el, index) => {
        const visible = index < count;
        el.hidden = !visible;
        el.classList.toggle('is-featured-off', !visible);
        el.setAttribute('aria-hidden', visible ? 'false' : 'true');
        if (visible) el.removeAttribute('tabindex');
        else el.setAttribute('tabindex', '-1');
        grid.appendChild(el);
      });
    };

    const openPanel = (panel, trigger) => {
      clearTimeout(closeTimer);
      if (panel.id !== 'MegaSearch' && isSearchOpen()) return;
      header.querySelectorAll('[data-mega-panel].is-open').forEach((p) => {
        if (p === panel) return;
        p.classList.remove('is-open');
        setTriggersExpanded(p, false);
      });
      panel.classList.add('is-open');
      setTriggersExpanded(panel, true);

      if (panel.id === 'MegaBrands') {
        shuffleFeaturedBrandLogos(panel);
      }

      if (panel.id.startsWith('MegaCat-')) {
        shuffleCatFeatured(panel);
      }

      if (panel.id === 'MegaSearch') {
        setSearchLock(true);
        const panelInput = panel.querySelector('[data-search-input]');
        if (panelInput) {
          requestAnimationFrame(() => {
            try {
              panelInput.focus({ preventScroll: true });
            } catch (err) {
              panelInput.focus();
            }
          });
        }
      } else {
        setSearchLock(false);
      }
    };

    const scheduleClose = (panel) => {
      if (panel && clickOnlyIds.has(panel.id)) return;
      clearTimeout(closeTimer);
      closeTimer = setTimeout(() => {
        if (!isDesktop()) return;
        closeAll();
      }, 200);
    };

    const cancelClose = () => clearTimeout(closeTimer);

    header.querySelectorAll('[data-mega-trigger]').forEach((trigger) => {
      const panelId = trigger.getAttribute('aria-controls');
      const panel = document.getElementById(panelId);
      if (!panel) return;
      const clickOnly = clickOnlyIds.has(panelId);

      if (!clickOnly) {
        trigger.addEventListener('mouseenter', () => {
          if (!isDesktop()) return;
          if (isSearchOpen()) return;
          openPanel(panel, trigger);
        });
        trigger.addEventListener('focus', () => {
          if (!isDesktop()) return;
          if (isSearchOpen()) return;
          openPanel(panel, trigger);
        });

        panel.addEventListener('mouseenter', cancelClose);
        panel.addEventListener('mouseleave', () => {
          if (!isDesktop()) return;
          if (isSearchOpen()) return;
          scheduleClose(panel);
        });

        const wrap = trigger.closest('[data-mega-item]');
        if (wrap) {
          wrap.addEventListener('mouseleave', (e) => {
            if (!isDesktop()) return;
            if (isSearchOpen()) return;
            const to = e.relatedTarget;
            if (to && (panel.contains(to) || wrap.contains(to))) return;
            scheduleClose(panel);
          });
        }
      }

      trigger.addEventListener('click', (e) => {
        if (trigger.hasAttribute('data-mega-nav-link')) return;
        e.preventDefault();
        const isOpen = panel.classList.contains('is-open');
        if (isOpen) {
          cancelClose();
          closeAll();
        } else {
          openPanel(panel, trigger);
        }
      });
    });

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      cancelClose();
      closeAll();
    });
  })();

  /* Mobile nav */
  const mobileNav = document.getElementById('MobileNav');
  const mobileToggles = document.querySelectorAll('[data-mobile-nav-toggle]');
  if (mobileNav && mobileToggles.length) {
    let mobileCloseTimer = null;
    const setMobileNav = (open) => {
      clearTimeout(mobileCloseTimer);
      mobileToggles.forEach((btn) => {
        btn.setAttribute('aria-expanded', String(open));
      });
      if (open) {
        mobileNav.hidden = false;
        requestAnimationFrame(() => {
          mobileNav.classList.add('is-open');
        });
        BP.lockScroll(true);
      } else {
        mobileNav.classList.remove('is-open');
        BP.lockScroll(false);
        const done = () => {
          if (mobileNav.classList.contains('is-open')) return;
          mobileNav.setAttribute('hidden', '');
        };
        mobileNav.addEventListener('transitionend', done, { once: true });
        mobileCloseTimer = setTimeout(done, 420);
      }
    };

    mobileToggles.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        setMobileNav(!mobileNav.classList.contains('is-open'));
      });
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && mobileNav.classList.contains('is-open')) {
        setMobileNav(false);
      }
    });
  }

  document.querySelectorAll('[data-accordion-toggle]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      const panelId = btn.getAttribute('aria-controls');
      const panel = panelId ? document.getElementById(panelId) : null;
      btn.setAttribute('aria-expanded', String(!expanded));
      if (panel) panel.hidden = expanded;
    });
  });

  /* Product tabs Photos / 3D */
  document.querySelectorAll('[data-product-tabs]').forEach((root) => {
    const tabs = root.querySelectorAll('[role="tab"]');
    const panels = root.querySelectorAll('[role="tabpanel"]');
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.getAttribute('aria-controls');
        tabs.forEach((t) => {
          t.setAttribute('aria-selected', 'false');
          t.tabIndex = -1;
        });
        panels.forEach((p) => {
          p.hidden = true;
        });
        tab.setAttribute('aria-selected', 'true');
        tab.tabIndex = 0;
        const panel = document.getElementById(target);
        if (panel) {
          panel.hidden = false;
          if (panel.dataset.loadIframe === 'true' && !panel.dataset.loaded) {
            const iframe = panel.querySelector('iframe[data-src]');
            if (iframe) {
              iframe.src = iframe.dataset.src;
              panel.dataset.loaded = 'true';
            }
          }
        }
      });
    });
  });

  /* Predictive search — product lookup */
  (function initPredictiveSearch() {
    const root = document.querySelector('[data-search-dropdown]');
    const searchInput = document.querySelector('[data-search-input]');
    if (!root || !searchInput) return;

    const productsList = root.querySelector('[data-search-products-list]');
    const seeAll = root.querySelector('[data-search-see-all]');
    const status = root.querySelector('[data-search-status]');
    let searchTimer;

    const clearResults = () => {
      if (productsList) productsList.innerHTML = '';
      if (seeAll) seeAll.hidden = true;
      if (status) {
        status.hidden = true;
        status.textContent = '';
      }
    };

    searchInput.addEventListener('input', () => {
      clearTimeout(searchTimer);
      const q = searchInput.value.trim();
      searchTimer = setTimeout(() => {
        if (!q) {
          clearResults();
          return;
        }
        const predictUrl = searchInput.dataset.predictiveUrl;
        if (!predictUrl) return;

        fetch(
          `${predictUrl}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8&section_id=predictive-search`
        )
          .then((r) => r.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const products = doc.querySelector('[data-predictive-products]');
            const seeAllSrc = doc.querySelector('[data-predictive-see-all]');

            if (productsList) productsList.innerHTML = products ? products.innerHTML : '';

            if (seeAll) {
              const link = seeAll.querySelector('a');
              const srcLink = seeAllSrc?.querySelector('a');
              if (link && srcLink && !seeAllSrc.hasAttribute('hidden')) {
                link.href = srcLink.getAttribute('href') || `/search?type=product&q=${encodeURIComponent(q)}`;
                seeAll.hidden = false;
              } else {
                seeAll.hidden = true;
              }
            }
          })
          .catch(() => clearResults());
      }, 200);
    });
  })();

  /* Language switcher uses native submit buttons (name=language_code) — no JS */

  /* Country / currency switcher */
  document.querySelectorAll('[data-country-input]').forEach((input) => {
    const form = input.closest('form');
    if (!form) return;

    const toggle = form.querySelector('[data-currency-toggle]');
    const list = form.querySelector('.country-selector__list');

    const closeList = () => {
      if (!list || !toggle) return;
      list.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
    };

    if (toggle && list) {
      toggle.addEventListener('click', (e) => {
        e.stopPropagation();
        const open = list.hidden;
        document.querySelectorAll('.country-selector__list').forEach((other) => {
          if (other !== list) other.hidden = true;
        });
        document.querySelectorAll('[data-currency-toggle]').forEach((btn) => {
          if (btn !== toggle) btn.setAttribute('aria-expanded', 'false');
        });
        list.hidden = !open;
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    form.querySelectorAll('[data-country]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const code = btn.getAttribute('data-country');
        if (!code || btn.classList.contains('is-active')) {
          closeList();
          return;
        }
        input.value = code;
        form.submit();
      });
    });
  });

  document.addEventListener('click', (e) => {
    if (e.target.closest('.country-selector')) return;
    document.querySelectorAll('.country-selector__list').forEach((list) => {
      list.hidden = true;
    });
    document.querySelectorAll('[data-currency-toggle]').forEach((btn) => {
      btn.setAttribute('aria-expanded', 'false');
    });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.country-selector__list').forEach((list) => {
      list.hidden = true;
    });
    document.querySelectorAll('[data-currency-toggle]').forEach((btn) => {
      btn.setAttribute('aria-expanded', 'false');
    });
  });

  /* Legacy select support */
  document.querySelectorAll('[data-country-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const form = select.closest('form');
      if (form) form.submit();
    });
  });

  /* Legacy attribute support if any older markup remains */
  document.querySelectorAll('[data-locale]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const form = btn.closest('form');
      if (!form) return;
      const input =
        form.querySelector('[data-language-input]') || form.querySelector('[data-locale-input]');
      if (!input) return;
      input.value = btn.getAttribute('data-locale');
      form.submit();
    });
  });

  /* Horizontal scroll carousels (PDP gallery, related products) */
  BP.bindHorizontalTrackWheel = function (track) {
    if (!track || track.dataset.bpHScrollWheel === 'true') return;
    track.dataset.bpHScrollWheel = 'true';

    track.addEventListener(
      'wheel',
      (e) => {
        const dy = e.deltaY;
        const dx = e.deltaX;
        const absY = Math.abs(dy);
        const absX = Math.abs(dx);

        /* Vertical intent must reach the page — never intercept */
        if (absY > absX || absX < 1) return;

        const max = track.scrollWidth - track.clientWidth;
        if (max <= 1) return;

        const left = track.scrollLeft;
        if ((dx < 0 && left <= 0) || (dx > 0 && left >= max - 1)) return;

        if (e.cancelable) e.preventDefault();
        track.scrollLeft += dx;
      },
      { passive: false }
    );
  };

  BP.initHScroll = function (root) {
    const track = root.querySelector('[data-h-scroll-track]');
    const prev = root.querySelector('[data-h-scroll-prev]');
    const next = root.querySelector('[data-h-scroll-next]');
    if (!track || !prev || !next) return;

    BP.bindHorizontalTrackWheel(track);

    const stepMode = root.getAttribute('data-h-scroll-step') || 'fraction';
    const slideWidth = () => track.clientWidth || 1;

    const itemStep = () => {
      const first = track.querySelector(':scope > *');
      if (!first) return 240;
      const gap = parseFloat(getComputedStyle(track).gap) || 0;
      return first.getBoundingClientRect().width + gap;
    };

    const scrollToIndex = (index) => {
      const items = [...track.querySelectorAll(':scope > *')];
      if (!items.length) return;
      const target = Math.min(Math.max(index, 0), items.length - 1);
      track.scrollTo({ left: items[target].offsetLeft, behavior: 'smooth' });
    };

    const slideIndex = () => {
      const items = [...track.querySelectorAll(':scope > *')];
      if (!items.length) return 0;
      const left = track.scrollLeft;
      let closest = 0;
      let min = Infinity;
      items.forEach((item, i) => {
        const dist = Math.abs(item.offsetLeft - left);
        if (dist < min) {
          min = dist;
          closest = i;
        }
      });
      return closest;
    };

    const step = () => {
      if (stepMode === 'page') return slideWidth();
      if (stepMode === 'item') return itemStep();
      return Math.max(track.clientWidth * 0.85, 240);
    };

    let scrollTicking = false;
    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      const overflow = max > 4;
      root.classList.toggle('has-overflow', overflow);
      if (stepMode === 'page') {
        const index = slideIndex();
        const last = Math.max(0, track.querySelectorAll(':scope > *').length - 1);
        prev.disabled = !overflow || index <= 0;
        next.disabled = !overflow || index >= last;
      } else {
        prev.disabled = !overflow || track.scrollLeft <= 4;
        next.disabled = !overflow || track.scrollLeft >= max - 4;
      }
      prev.hidden = !overflow;
      next.hidden = !overflow;
    };

    const scheduleUpdate = () => {
      if (scrollTicking) return;
      scrollTicking = true;
      requestAnimationFrame(() => {
        scrollTicking = false;
        update();
      });
    };

    prev.addEventListener('click', () => {
      if (stepMode === 'page') scrollToIndex(slideIndex() - 1);
      else track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next.addEventListener('click', () => {
      if (stepMode === 'page') scrollToIndex(slideIndex() + 1);
      else track.scrollBy({ left: step(), behavior: 'smooth' });
    });
    track.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate, { passive: true });
    if ('ResizeObserver' in window) {
      new ResizeObserver(scheduleUpdate).observe(track);
    }

    update();
  };

  document.querySelectorAll('[data-h-scroll]').forEach((el) => BP.initHScroll(el));
  document.querySelectorAll('[data-h-scroll-track]').forEach((track) => BP.bindHorizontalTrackWheel(track));

  /* Scroll reveal — all main sections & inner blocks */
  BP.initScrollReveal = function (root) {
    const scope = root && root.nodeType === 1 ? root : document;
    const main = scope.id === 'MainContent' ? scope : scope.querySelector('#MainContent') || scope;
    if (!main) return;

    /* PDP: never hide sections behind opacity:0 — CTAs / media must stay interactive */
    if (document.body.classList.contains('template-product')) {
      main.querySelectorAll('.shopify-section, .scroll-reveal, .scroll-reveal-item').forEach((el) => {
        el.classList.add('is-revealed');
      });
      return;
    }

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const sections = main.matches?.('.shopify-section')
      ? [main]
      : [...main.querySelectorAll(':scope > .shopify-section:not([data-reveal-skip])')];

    const itemSelector = [
      ':scope > .container > *',
      ':scope > .container [class*="__layout"] > *',
      ':scope [class*="__grid"] > *',
      ':scope [class*="__track"] > *',
      ':scope [class*="__values-grid"] > *',
    ].join(', ');

    const inViewport = (el) => {
      const rect = el.getBoundingClientRect();
      return rect.top < window.innerHeight * 0.92 && rect.bottom > 0;
    };

    const reveal = (el) => {
      el.classList.add('is-revealed');
    };

    if (!BP._scrollRevealObserver) {
      BP._scrollRevealObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            reveal(entry.target);
            BP._scrollRevealObserver.unobserve(entry.target);
          });
        },
        { root: null, rootMargin: '0px 0px -7% 0px', threshold: 0.1 }
      );
    }

    const observer = BP._scrollRevealObserver;

    sections.forEach((section) => {
      if (section.dataset.revealInit === 'true') return;
      section.dataset.revealInit = 'true';

      const items = [...new Set([...section.querySelectorAll(itemSelector)])].filter(
        (el) =>
          !el.closest('[data-reveal-skip]') &&
          !el.closest('[data-h-scroll-track]') &&
          !el.matches('[data-reveal-skip]')
      );

      if (reducedMotion) {
        reveal(section);
        items.forEach(reveal);
        return;
      }

      if (items.length > 1) {
        items.forEach((item, index) => {
          item.classList.add('scroll-reveal-item');
          item.style.setProperty('--reveal-delay', `${Math.min(index * 75, 400)}ms`);
          if (inViewport(item)) reveal(item);
          else observer.observe(item);
        });
        return;
      }

      section.classList.add('scroll-reveal');
      if (inViewport(section)) reveal(section);
      else observer.observe(section);
    });
  };

  BP.initScrollReveal();

  /* Shuffle product grids (collection page + featured sections) */
  BP.shuffleChildren = function (container) {
    const items = Array.from(container.children);
    if (items.length < 2) return;
    for (let i = items.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      const tmp = items[i];
      items[i] = items[j];
      items[j] = tmp;
    }
    items.forEach((el) => container.appendChild(el));
  };

  BP.initProductShuffle = function (scope) {
    const root = scope || document;
    root.querySelectorAll('[data-shuffle-products]').forEach((el) => {
      if (el.hasAttribute('data-shuffle-respect-sort')) {
        const sortBy = new URLSearchParams(window.location.search).get('sort_by');
        if (sortBy && sortBy !== 'manual') return;
      }
      BP.shuffleChildren(el);
    });
  };

  BP.initProductShuffle();

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target) {
      BP.initScrollReveal(event.target);
      BP.initProductShuffle(event.target);
    }
  });

  /* Analytics helpers */
  BP.track = function (eventName, params) {
    if (window.BPConsent && !window.BPConsent.analytics) return;
    if (typeof gtag === 'function') {
      gtag('event', eventName, params || {});
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...(params || {}) });
  };

  /* Variant swatch buttons → hidden selects */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-swatch-value]');
    if (!btn) return;
    const root = btn.closest('[data-variant-selector]');
    if (!root) return;
    const index = btn.getAttribute('data-option-index');
    const value = btn.getAttribute('data-swatch-value');
    const select = root.querySelector(`select[data-option-index="${index}"]`);
    if (!select) return;
    select.value = value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
    root.querySelectorAll(`[data-swatch-group="${index}"] [data-swatch-value]`).forEach((el) => {
      const on = el === btn;
      el.classList.toggle('is-selected', on);
      el.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    const label = root.querySelector(`[data-option-label="${index}"]`);
    if (label) label.textContent = value;
  });
})();
